import { render, staticRenderFns } from "./mailings-list-page.vue?vue&type=template&id=16391fa2&"
import script from "./mailings-list-page.vue?vue&type=script&lang=js&"
export * from "./mailings-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports